/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Preferences_Channel_TvInputs */

const de_notifications_preferences_channel_tv = /** @type {(inputs: Notifications_Preferences_Channel_TvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TV-Banner`)
};

/** @type {(inputs: Notifications_Preferences_Channel_TvInputs) => LocalizedString} */
const en_notifications_preferences_channel_tv = de_notifications_preferences_channel_tv;

/**

* @param {Notifications_Preferences_Channel_TvInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_preferences_channel_tv = /** @type {((inputs?: Notifications_Preferences_Channel_TvInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Preferences_Channel_TvInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notifications_preferences_channel_tv(inputs)
	return en_notifications_preferences_channel_tv(inputs)
});